import { on } from '../utils/_fn';
import LazyLoad from '../vendor/lazyload.min.js';

export function initLazyLoad() {
  /* ---------------------------------------- [START] Lazyload */
  /*
   * 使用：https://github.com/verlok/vanilla-lazyload
   * 尋找頁面上的 .lazy 為執行 Lazy Load 物件
   */

  function initLazyLoadInstance() {
    new LazyLoad({
      // Your custom settings go here
    });
  }

  on(window, 'load', initLazyLoadInstance);

  window.LazyLoad = LazyLoad;
  /* ---------------------------------------- [END] Lazyload */
}
